/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/history">
                        History
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/staff">Staff</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/policies">
                        Policies
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/events">Calendar</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>The school</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/academics">Academics</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/culture">Culture</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/sport">Sport</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/hostel">Hostel</UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Admissions</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/admissions/applications">
                        Applications
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/admissions/fee-structure">
                        Fee Structure
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/admissions/school-uniform">
                        School Uniform
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/admissions/e-devices">
                        e-Devices
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>More</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/contact">
                        Contact
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/alumnae">
                        Alumnae
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://facebook.com/rhenish.girls.high"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://instagram.com/rhenishgirlshigh"
                            target="_blank"
                            title="Instagram"
                          >
                            <i class="bi bi-instagram"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Rhenish Girls' High School {current_year}"
                        defaultMessage="{copyright} Rhenish Girls' High School {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of{" "}
                      <a href="https://www.pexels.com" target="_blank">
                        Pexels
                      </a>{" "}
                      &{" "}
                      <a href="https://unsplash.com" target="_blank">
                        Unsplash
                      </a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-square"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
